module.exports = __webpack_public_path__ + "img/bdx-clear-filters-icon.399b4bd8.png";